const TYPE_4_OPTIONS = {
  3: true,
  7: true,
  8: true,
  9: true
};
const FORM_STYLE = {
  0: "qform-default",
  // 0: Поля с обводкой
  1: "qform-background",
  // 1: Поля с фоном
  2: "qform-underline",
  // 2: Поля с подчеркиванием
  3: "qform-default-background",
  // 3: Поля с фоном и обводкой
  4: "qform-underline-background" // 4: Поля с фоном и подчеркиванием
};
const FIELD_SIZE = {
  0: "qform-size-sm",
  1: "qform-size-md",
  2: "qform-size-lg"
};
const FIELD_RADIUS = {
  0: "qform-radius-0px",
  1: "qform-radius-5px",
  2: "qform-radius-25px"
};
const DEFAULT_OPTIONS = {
  method: "POST",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
  },
  mode: "cors",
  cache: "no-cache",
  credentials: "same-origin",
  redirect: "follow",
  referrerPolicy: "no-referrer"
};

/**
 * may be deprecated
 *
 * @type {{"0": string, "1": string, "2": string, "3": string}}
 */
const FIELD_LABEL = {
  0: "qform-label_inside_show",
  1: "qform-label_inside_hide",
  2: "qform-label_outside_left",
  3: "qform-label_outside_top"
};
export { TYPE_4_OPTIONS, FORM_STYLE, FIELD_SIZE, FIELD_RADIUS, FIELD_LABEL, DEFAULT_OPTIONS };